import {imageURLDefault, OBJECT_TYPES} from "../constants/project";

export const ImageObject = {
  objectType: OBJECT_TYPES.IMAGE,
  attributes: [
    {
      name: "url",
      defaultValue: imageURLDefault,
      validation: [{ required: true, message: "Please input the url!" }],
      type: "string",
      validValues: [],
      disabled: false,
      autoFocus: true,
      hint: (
        <div>
          enter url to image here. You can also use datauri:// for small
          embedded images or scanned signatures. Use{" "}
          <a href="https://pdflite.co/image-to-base64/index.html">this tool </a>
          to convert small image into datauri:// link
        </div>
      ),
    },
    {
      name: "x",
      defaultValue: "",
      validation: [{ required: true, message: "Please input the x!" }],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "y",
      defaultValue: "",
      validation: [{ required: true, message: "Please input the y!" }],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "width",
      defaultValue: "",
      validation: [],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "height",
      defaultValue: "",
      validation: [],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "pages",
      defaultValue: "0",
      validation: [],
      type: "string",
      validValues: [],
      disabled: false,
    },
    {
      name: "link",
      defaultValue: "",
      validation: [],
      type: "string",
      validValues: [],
      disabled: false,
    },
    {
      name: "keepAspectRatio",
      defaultValue: true,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
  ],
};
